import classNames from "classnames";
import * as React from "react";
import Anchor from "../anchor/anchor";

export interface ContentSectionProps {
    className?: string;
    type?: "default" | "full";
    anchorId?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({
    className,
    type = "default",
    anchorId,
    hasNoMarginTop,
    hasNoMarginBottom,
    ...props
}) => {
    const baseClass = "content-section";
    const componentClasses = classNames(baseClass, className, {
        [`${baseClass}--full`]: type === "full",
        "anchor-wrapper": !!anchorId,
        "content-no-margin-top": hasNoMarginTop,
        "content-no-margin-bottom": hasNoMarginBottom
    });
    return (
        <section className={componentClasses}>
            {anchorId && <Anchor id={anchorId} />}
            {props.children}
        </section>
    );
};

export default ContentSection;
